import React from 'react'
import { useHistory } from 'react-router-dom'
import styles from './Cart.module.scss'

const CartHeader = ({ removeAll }) => {
  const { goBack } = useHistory()

  return (
    <div className={styles.header}>
      <div className={styles.wrapper}>
        <div className={styles.arrow} onClick={goBack}></div>
        <div className={styles.title}>购物袋</div>
      </div>
      <div className={styles['remove-all']} onClick={removeAll}>
        清空购物袋
      </div>
    </div>
  )
}

export default CartHeader
